module.exports = __webpack_public_path__ + "img/filter.6f59e668.svg";